export default "__VITE_ASSET__BHCIOaEg__"